import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

import config from '../config/config'
import ManageItemPhoto from './ManageItemPhoto'
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext'

const ManageItemPhotosList = ({
  item,
  itemType,
  refreshList,
  handleUpdatePhotoRanking,
}) => {
  const { t } = useTranslation()
  const [photos, setPhotos] = useState([])

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}photo?media-key=${itemType}_MEDIA_KEY_${item.id}`,
        )
        setPhotos(response.data)
      } catch (error) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.log('Erreur lors du GET photo', item.id)
      }
    }

    fetchPhotos()
  }, [item.id, refreshList, t])

  return (
    <div>
      {photos && photos.length > 0 && (
        <div>
          <h2>{t('MANAGE_PHOTOS')}</h2>
          {photos.map((photo) => (
            <ManageItemPhoto
              key={`${photo.id}-${photo.ranking}`}
              photo={photo}
              handleUpdatePhotoRanking={handleUpdatePhotoRanking}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default ManageItemPhotosList
